module.exports = __webpack_public_path__ + "img/A2.60b32e10.jpg";